import { FC } from 'react'

import { AppIcon } from 'shared/ui/app-icon'
import { AllIcons } from 'shared/ui/app-icon/types'

import s from './styles.module.scss'

interface Props {
  title?: string
  onClick?: () => void
}

export const SelectedItem: FC<Props> = ({ title, onClick }) => {
  return (
    <div
      className={s.container}
      onClick={onClick}
    >
      {title}
      <span className={s.wrapperIcon}>
        <AppIcon
          id={AllIcons.CROSS_BOLD}
          className={s.icon}
          height={14}
          width={14}
        />
      </span>
    </div>
  )
}
